





















































































import { Component, Vue, Prop, Model, Watch } from 'vue-property-decorator';

/**
 * Helpers
 */
import { getYearMonthString, getDateString } from "@/utils/date-helpers";

/**
 * Types
 */
interface Event {
	color: string;
	character: string | null;
	size: string | null;
}

/**
 * Composant de calendrier mensuel.
 */
@Component
export default class CalendarPicker extends Vue {
	$refs!: {
		calendar: any
	};

	/** Propriétés */
	@Prop()
	allowedDates!: (isoDate: string) => boolean;

	@Prop()
	min: string | undefined;
	@Prop()
	max: string | undefined;

	@Prop()
	events!: (date: string) => Event[];

	@Prop({ default: 'fr-FR' })
	locale!: string;

	/** v-model */
	@Model('date-changed')
	date: any;

	/** Attributs */
	menu: boolean = false;
	dateStart: string | null = null;
	pickerDate: string | null = null;
	currentDate = null;
	colorEvents = (date: string) => this.events(date);


	/** Watchers */
	@Watch('date')
	dateWatcher(date: any) {
		this.currentDate = date;
	}

	@Watch('pickerDate')
	pickerDateChanged(val: string, oldVal: string) {
		if (val !== oldVal) {
			this.currentDate = null;
		}
		this.dateStart = val + '-01';
		this.menu = false;
		this.$emit('monthChanged', val);
	}

	@Watch('currentDate')
	currentDateWatcher(date: any) {
		this.onDateChanged(date);
	}


	/** Méthodes */
	created() {
		this.pickerDate = getYearMonthString(new Date());
	}

	onDateChanged(date: any) {
		this.$emit('date-changed', date);
	}
	onRangeChanged({ start, end }: any) {
		this.dateStart = start.date;
		this.menu = false;
		this.pickerDate = getYearMonthString(new Date(start.date));
	}

	previousMonth() {
		this.$refs.calendar.prev();
		this.currentDate = null;
	}
	nextMonth() {
		this.$refs.calendar.next();
		this.currentDate = null;
	}

	get minVal() {
		return this.min;
	}

	get maxVal() {
		return this.max;
	}

	isDateAllowed(date: any) {
		return this.allowedDates(date) && (this.minVal == null || new Date(this.minVal) <= new Date(date));
	}

	functionEvents = (date: string) => {
		const [, , day] = date.split('-');
		return parseInt(day, 10) % 3 === 0;
	}
}
